import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OfflineService {
  private failedRequests: HttpRequest<any>[] = [];
  private online$ = new BehaviorSubject<boolean>(navigator.onLine);

  constructor(private http: HttpClient) {
    window.addEventListener('online', () => this.handleConnectionChange(true));
    window.addEventListener('offline', () => this.handleConnectionChange(false));
  }

  private handleConnectionChange(status: boolean) {
    this.online$.next(status);
    if (status) {
      this.retryFailedRequests();
    }
  }

  storeFailedRequest(request: HttpRequest<any>) {
    this.failedRequests.push(request);
  }

  private retryFailedRequests() {
    while (this.failedRequests.length > 0) {
      const request = this.failedRequests.shift();
      if (request) {
        this.http.request(request).subscribe();
      }
    }
  }
}